module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = react
// module chunks = 0